import styled, { css, DefaultTheme } from 'styled-components';
import { Field as UnstyledField } from 'formik';

type LabelProps = {
  required?: boolean;
};

type FieldProps = {
  icon?: boolean;
  isValid?: boolean;
};

type FeedbackMessageProps = {
  color: string;
};

const labelModifiers = {
  required: (theme: DefaultTheme) => css`
    &::after {
      content: '*';
      margin-left: 8px;
      vertical-align: middle;
      color: ${theme.colors.statusDanger50};
    }
  `,
};

export const Container = styled.div`
  position: relative;

  width: 100%;
`;

export const Label = styled.label<LabelProps>`
  ${({ theme, required }) => css`
    font-weight: 400;
    font-size: 1.4rem;

    display: block;

    letter-spacing: 1px;
    text-transform: uppercase;

    margin-bottom: 1.2rem;

    color: ${theme.colors.neutralDark80};

    ${required && labelModifiers.required(theme)}
  `};
`;

export const Field = styled(UnstyledField)<FieldProps>`
  ${({ theme, icon, isValid }) => css`
    width: 100%;
    height: 4.8rem;

    padding: 1.6rem;
    font-size: 1.4rem;

    border: 1px solid
      ${isValid ? theme.colors.neutralDark20 : theme.colors.statusDanger50};
    border-radius: 0.4rem;
    outline: none;

    padding-right: ${icon ? '4.4rem' : '1.6rem'};

    &::placeholder {
      font-weight: 400;
      font-size: 1.4rem;
      color: ${theme.colors.neutralDark40};
    }
  `};
`;

export const IconContainer = styled.div`
  height: 2.8rem;

  display: flex;
  align-items: center;

  position: absolute;
  right: 1.6rem;
  top: 1rem;
`;

export const FeedbackMessage = styled.span<FeedbackMessageProps>`
  ${({ color }) => css`
    font-weight: 300;
    font-size: 1.2rem;

    display: block;
    margin-top: 0.4rem;

    a {
      color: ${color};
      font-weight: 700;
      text-decoration: none;
    }

    color: ${color};
  `};
`;
